import { AspectRatio, Flex } from "@chakra-ui/react";
import { FillImage } from "components/images";
import React from "react";
import realTimeImage from "../../../../public/assets/platform/customer-studio/real-time.png";

export function RealTimeImage() {
  return (
    <Flex bg="new.blue.150" bgGradient="linear(130deg, new.blue.150, new.blue.300 120%)" boxSize="100%" pos="relative">
      <AspectRatio
        ratio={752 / 618}
        pos="relative"
        w="90%"
        ml="auto"
        borderLeftRadius="smaller"
        overflow="hidden"
        boxShadow="lg"
      >
        <FillImage
          src={realTimeImage}
          alt="UI screenshot of an audience named 'Hotel booking points upsell' with the realtime toggle enabled. The audience filter shows 'Performed Flight search at least 1 time within 15 minutes ago.'"
        />
      </AspectRatio>
    </Flex>
  );
}
